import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import App from "./App";

import "./index.css";
import About from "./About";
import PrivacyPolicy from "./PrivacyPolicy";
import Terms from "./Terms";
import LunaTarotPrivacyPolicy from "./LunaTarotPrivacyPolicy";
import LunaTarotAbout from "./LunaTarotAbout";
import LunaTarotLanding from "./LunaTarotLanding";
import KanaTomoLanding from "./KanaTomoLanding";
import LunaTarotTerms from "./LunaTarotTerms";
import AddUpTerms from "./AddUpTerms";
import AddUpPrivacyPolicy from "./AddUpPrivacyPolicy";
import AddUpLanding from "./AddUpLanding";
import StirredLanding from "./StirredLanding";
import StirredTerms from "./StirredTerms";
import StirredPrivacyPolicy from "./StirredPrivacyPolicy";
import VeilTerms from "./VeilTerms";
import VeilPrivacyPolicy from "./VeilPrivacyPolicy";
import DailySignLanding from "./DailySignLanding";
import DailySignTerms from "./DailySignTerms";
import DailySignPrivacyPolicy from "./DailySignPrivacyPolicy";
import RoadmapShare from "./RoadmapShare";
import Links from "./Links";
import AnalyticsTracker from "./AnalyticsTracker";

function NotFound() {
  return (
    <div style={{ textAlign: "center", padding: "20vh 16px", fontFamily: "system-ui, sans-serif" }}>
      <h2>404 | Page Not Found</h2>
      <p style={{ marginTop: 8 }}>
        <a href="/" style={{ color: "#0ea5e9", textDecoration: "none" }}>Go Home</a>
      </p>
    </div>
  );
}

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AnalyticsTracker />
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="*" element={<NotFound />} />

        <Route path="/about" element={<About />} /> {/* 추가 */}
        <Route path="/kanatomo" element={<KanaTomoLanding />} />
        <Route path="/lunatarot" element={<LunaTarotLanding />} />
        <Route path="/lunatarot/terms" element={<LunaTarotTerms />} />
        <Route path="/lunatarot/privacy" element={<LunaTarotPrivacyPolicy />} /> {/* 추가 */}
        <Route path="/lunatarot/about" element={<LunaTarotAbout />} /> {/* 추가 */}
        <Route path="/addup" element={<AddUpLanding />} />
        <Route path="/stirred" element={<StirredLanding />} />
        <Route path="/stirred/terms" element={<StirredTerms />} />
        <Route path="/stirred/privacy" element={<StirredPrivacyPolicy />} />
        <Route path="/veil/terms" element={<VeilTerms />} />
        <Route path="/veil/privacy" element={<VeilPrivacyPolicy />} />
        <Route path="/dailysign" element={<DailySignLanding />} />
        <Route path="/dailysign/terms" element={<DailySignTerms />} />
        <Route path="/dailysign/privacy" element={<DailySignPrivacyPolicy />} />
        <Route path="/addup/terms" element={<AddUpTerms />} />
        <Route path="/addup/privacy" element={<AddUpPrivacyPolicy />} />
        {/* Add Up 로드맵 공유 링크. 앱이 깔려 있으면 Universal Links 가 가로채
            앱이 직접 연다 — 여기까지 오면 앱이 없거나 데스크톱이다. */}
        <Route path="/r/:data" element={<RoadmapShare />} />
        {/* 소셜 프로필(틱톡 등) 링크 인 바이오: 스토어 버튼만 모은 짧은 페이지 */}
        <Route path="/links" element={<Links />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);
